import type { ExpressionSpecification } from 'mapbox-gl'

export const SLOPE_FALLBACK_COLOR = '#888888'

// Expression Mapbox unique : les couches lisent la couleur posee sur la feature,
// jamais une enumeration de libelles.
export const SLOPE_COLOR_EXPRESSION: ExpressionSpecification = [
  'coalesce',
  ['get', 'color'],
  SLOPE_FALLBACK_COLOR,
]

const HEX = /^#[0-9a-fA-F]{6}$/

export type ColouredCategory = {
  id?: number | string
  name?: string
  color?: string | null
  parent?: { id?: number | string; name?: string; color?: string | null } | null
}

export type CategoryNode = ColouredCategory & {
  children?: CategoryNode[] | null
}

// La couleur vient de la base depuis le lot 1 : toute constante en dur redevient
// fausse des qu'une station cree sa propre categorie.
export const slopeCategoryColor = (
  slope?: {
    category?: ColouredCategory | null
  } | null,
): string => {
  const own = slope?.category?.color
  if (own && HEX.test(own)) return own
  // defensif : le payload piste replie le parent en { id, name } sans couleur
  // (foldSlopeRow, back) — cette branche ne sert qu'aux noeuds d'arbre
  const parent = slope?.category?.parent?.color
  if (parent && HEX.test(parent)) return parent
  return SLOPE_FALLBACK_COLOR
}

const normalize = (name?: string | null) =>
  typeof name === 'string' ? name.trim().toLowerCase() : ''

const findByName = (
  nodes: CategoryNode[] | null | undefined,
  wanted: string,
): CategoryNode | null => {
  if (!Array.isArray(nodes) || !wanted) return null
  for (const node of nodes) {
    if (normalize(node?.name) === wanted) return node
    const child = findByName(node?.children, wanted)
    if (child) return child
  }
  return null
}

// Un GeoJSON importe ne porte qu'un libelle : la couleur se retrouve par nom dans
// l'arbre du resort, jamais par une table de correspondance figee.
export const slopeCategoryColorByName = (
  categories: CategoryNode[] | null | undefined,
  name?: string | null,
): string =>
  slopeCategoryColor({ category: findByName(categories, normalize(name)) })
